import { useDispatch } from 'react-redux';
import { HelicopterIcon } from '@rsos/assets/icons';
import {
  setResourcePanelView,
  setSelectedRequest,
  markTransportSeen,
  useIsResourcePanelOpen,
  useResourcePanelView,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import { ResourceOption } from '../types';
import AirAmbulanceView from './AirAmbulanceView';
import BreadCrumbs from './BreadCrumbs';
import NewRequestView from './NewRequestView';
import RequestListView from './RequestListView';
import { PanelContainer } from './ResourceRequestPanel.styles';

const RESOURCE_OPTIONS: ResourceOption[] = [
  {
    id: 'air_ambulance',
    title: 'Air Ambulance',
    source: 'GMR',
    description:
      'Request emergency helicopter services for severe medical emergencies',
    Icon: HelicopterIcon,
  },
];

/**
 * ResourceRequestPanel is a right-hand slide-in panel that routes between
 * three views: list_requests (default), new (resource type selector), and
 * air_ambulance (form/status). PanelContainer is rendered here once so that
 * view switches don't unmount/remount it — preserving the width transition.
 */
function ResourceRequestPanel() {
  const dispatch = useDispatch();
  const isOpen = useIsResourcePanelOpen();
  const view = useResourcePanelView();

  const handleNewRequest = () => {
    dispatch(setSelectedRequest(null));
    dispatch(setResourcePanelView('new'));
  };

  const handleResourceClick = (resourceId: string) => {
    dispatch(setResourcePanelView(resourceId as 'air_ambulance'));
  };

  const handleSelectTransport = (id: string) => {
    dispatch(markTransportSeen(id));
    dispatch(setSelectedRequest(id));
    dispatch(setResourcePanelView('air_ambulance'));
  };

  return (
    <PanelContainer isOpen={isOpen} data-name="resource-request-panel">
      <BreadCrumbs />
      {view === 'air_ambulance' && <AirAmbulanceView />}
      {view === 'new' && (
        <NewRequestView
          resourceOptions={RESOURCE_OPTIONS}
          onResourceClick={handleResourceClick}
        />
      )}

      {
        // NOTE: We don't want to mount/render the RequestListView unless the
        //   panel is open as it is triggeres requests *with polling* to
        //   etl_integrations to populate the list.
        isOpen && view === 'list_requests' && (
          <RequestListView
            onNewRequest={handleNewRequest}
            onSelectTransport={handleSelectTransport}
          />
        )
      }
    </PanelContainer>
  );
}

export default ResourceRequestPanel;
